module.exports = __webpack_public_path__ + "static/media/circular-red-close-icon.d2769af4.svg";